import { createFileRoute } from "@tanstack/react-router";

import { AdminLanguagePage } from "@/features/settings/admin-language/admin-language-page";

export const Route = createFileRoute("/settings/language")({
  component: AdminLanguagePage,
});
